<template>
    <div>
        <div class="row gy-2">
            <div class="col-12">
                <h5 class="mb-3">List of your verifications</h5>
                <div class="row mb-3 gy-2 justify-content-between">
                    <div class="col-md-6 col-lg-4 d-flex">
                        <div class="input-group w-auto">
                            <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage"
                                :options="pageOptions"></b-form-select>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="input-group mb-0">
                            <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control"
                                placeholder="Search here..." aria-label="Search here..."
                                aria-describedby="button-search_TB">
                            <button @click="fetchItems()" class="btn btn-primary" type="button"
                                id="button-search_TB"><span class="ri ri-search-line"></span></button>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <p class="mb-0">Showing {{ paginationInfo }} results</p>
                </div>
                <div v-if="isLoading" class="row g-3 g-lg-4">
                    <div v-for="(data, dIndex) in 2" :key="dIndex" class="col-sm-6">
                        <div class="card h-100 mb-0 card-animate overflow-hidden" style="min-height: 300px;">
                            <CommonSkeletonLoader v-if="isLoading" />
                        </div>
                    </div>
                </div>
                <div v-else class="row g-3 g-lg-4">
                    <div v-for="(data, dIndex) in pageData.data" :key="dIndex" class="col-sm-6">
                        <div class="card h-100">
                            <div class="card-body p-3 d-flex flex-column justify-content-between">
                                <div>
                                    <h5 class="mb-4">{{ data.verification_title }}</h5>
                                    <p class="mb-2"><label class="mb-0 text-muted">Status:</label> <strong><span v-html="statusBadge(data.status)"></span></strong></p>
                                    <div class="mb-2">
                                        <label class="mb-1 text-muted">Verification Start date</label>
                                        <p class="mb-0">{{ $filters.date(data.verification_start_at, 2) }}</p>
                                    </div>
                                    <div class="mb-2">
                                        <label class="mb-1 text-muted">Verification Deadline</label>
                                        <p class="mb-0">{{ $filters.date(data.verification_end_at, 2) }}</p>
                                    </div>
                                </div>
                                <div class="d-grid">
                                    <router-link class="btn btn-sm btn-primary" :to="`/verifications/${data.id}`"> View details</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="my-4">
                    <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
                        :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import _ from 'lodash';
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';

export default {
    name: "verification",
    mixins: [
        commonSortingMixin,
        commonPaginationMixin,
    ],
    data() {
        return {
            isLoading: false,
            searchQuery: "",
            columns: [
                { key: "check", },
                "action",
                { key: 'status', clickable: true, auto: true, width:6, label: 'Verification Status' },
                { key: 'bvn_photo_status', clickable: false, width:7, auto: true, label: 'BVN Photo Status', sortable: true },
                { key: 'nin_photo_status', clickable: false, width:7, auto: true, label: 'NIN Photo Status', sortable: true },
                { key: 'bvn_first_name_status', clickable: true, width: 10, auto: true, label: 'BVN First Name Status', sortable: true },
                { key: 'bvn_last_name_status', clickable: true, width: 10, auto: true, label: 'BVN Last Name Status', sortable: true },
                { key: 'nin_first_name_status', clickable: true, width: 10, auto: true, label: 'NIN First Name Status', sortable: true },
                { key: 'nin_last_name_status', clickable: true, width: 10, auto: true, label: 'NIN Last Name Status', sortable: true },
                { key: 'min_verification_passed', clickable: true, auto: true, label: 'Min Verification', sortable: true },
                { key: 'manual_check_passed', clickable: true, width: 8, width:5, auto: true, label: 'Manual Check', sortable: true },
                { key: 'all_verification_passed', clickable: true, auto: true, label: 'All Verification', sortable: true },
                { key: 'bvn_status', clickable: true, width: 6, auto: true, label: 'BVN Status', sortable: true },
                { key: 'nin_status', clickable: true, width: 6, auto: true, label: 'NIN Status', sortable: true },
                { key: "created_at", clickable: true, auto: true, width: 7, label: "Created at", sortable: true }
            ],
            sortBy: {
                sort_column: "created_at",
                sort_direction: "desc"
            },
            pageData: {
                data: []
            },
        }
    },
    methods: {
        navigateTo(id) {
            if (id) {
                this.$router.push({ path: `/verifications/${id}` })
            }
        },
        updateItem(item) {
            const dataIndex = this.pageData.data.findIndex((i) => i.id == item.id);
            Object.assign(this.pageData.data[dataIndex], item);
        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
                ...this.sortBy,
                ...this.$filters.validFields({
                    ...(this.queryFilters ?? {})
                })
            }
            if (this.searchQuery) { payload.search = this.searchQuery }
            this.isLoading = true
            this.$http.get(`/verification-results?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        initializeAll() {
        },
    },
    mounted() {
        this.fetchItems()
    },
}
</script>


<style>
.accordion .accordion-body {
    color: var(--bs-gray-800) !important;
}
</style>